import { render, staticRenderFns } from "./ComplaintClassifyCell.vue?vue&type=template&id=014b8739&scoped=true"
import script from "./ComplaintClassifyCell.vue?vue&type=script&lang=js"
export * from "./ComplaintClassifyCell.vue?vue&type=script&lang=js"
import style0 from "./ComplaintClassifyCell.vue?vue&type=style&index=0&id=014b8739&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014b8739",
  null
  
)

export default component.exports